import {
    BackspaceOutlined as BackspaceOutlinedIcon,
    DeleteForeverOutlined as DeleteForeverOutlinedIcon,
    EditTwoTone as EditTwoToneIcon,
    Search as SearchIcon,
    VisibilityOutlined as VisibilityOutlinedIcon
} from '@material-ui/icons';
import {
    Button,
    Card,
    CardContent,
    Input,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip
} from '@material-ui/core';
import { ANAO, ASIM } from 'consts';
import api from '../../../services/api';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import DeleteConfirmationModal from '../../../components/DeleteConfirmationModal/DeleteConfirmationModal';

class OpcionalVeiculoList extends Component {
    state = {
        searchFilter: JSON.parse(sessionStorage.getItem('opcionalveiculoSearchFilter')) || {
            descopcionalveiculo: '',
            situacaoInativoFilter: ANAO
        },
        opcionaisveiculos: [],
        open: false,
        openAlert: false,
        messageAlert: '',
        selectedId: null,
        selectedDesc: null,
        totalItems: 0,
        page: Number(sessionStorage.getItem('opcionalveiculoPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('opcionalveiculoRowsPerPage')) || 10
    };

    estilo = {
        redText: { color: 'red' },
        addButton: {
            height: 42,
            display: 'flex',
            alignItems: 'center'
        },
        iconGroup: {
            display: 'inline-flex',
            gap: 5
        },
        actionIcon: {
            fontSize: 24,
            color: '#3f51b5',
            cursor: 'pointer'
        },
        marginTop: 30,
        marginLeft: 30,
        marginRight: 30
    };

    /* Altera a cor do ícone ao passar o cursor */
    handleIconMouseEnter = (event) => {
        event.currentTarget.style.color = '#2979ff';
    };

    /* Retorna à cor padrão do ícone ao remover o cursor */
    handleIconMouseLeave = (event) => {
        event.currentTarget.style.color = '#3f51b5';
    };

    /* Altera a cor do ícone de exclusão ao passar o cursor */
    handleDeleteIconMouseEnter = (event) => {
        event.currentTarget.style.color = 'red';
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this.loadOpcionaisVeiculo();
    };

    /* Paginação */
    componentDidUpdate(prevProps, prevState) {
        const { page, rowsPerPage, searchFilter } = this.state;

        // persiste os filtros e a paginação no sessionStorage
        if (prevState.searchFilter !== searchFilter) {
            sessionStorage.setItem('opcionalveiculoSearchFilter', JSON.stringify(searchFilter));
        }

        if (prevState.page !== page) {
            sessionStorage.setItem('opcionalveiculoPage', page);
        }

        if (prevState.rowsPerPage !== rowsPerPage) {
            sessionStorage.setItem('opcionalveiculoRowsPerPage', rowsPerPage);
        }
    };

    /* Limpa os filtros e a paginação ao sair da tela */
    componentWillUnmount() {
        sessionStorage.removeItem('opcionalveiculoSearchFilter');
        sessionStorage.removeItem('opcionalveiculoPage');
        sessionStorage.removeItem('opcionalveiculoRowsPerPage');
    };

    /* Carrega os opcionais de veículo */
    loadOpcionaisVeiculo = async () => {
        const { searchFilter, page, rowsPerPage } = this.state;
        const { descopcionalveiculo, situacaoInativoFilter } = searchFilter;

        let params = `?page=${page + 1}&limit=${rowsPerPage}`;

        if (descopcionalveiculo) {
            params += `&DESCOPCIONALVEICULO=_like_${descopcionalveiculo}`;
        }

        if (situacaoInativoFilter === ASIM || situacaoInativoFilter === ANAO) {
            params += `&INATIVO=${situacaoInativoFilter}`;
        }

        try {
            const response = await api.get('/opcionalveiculo' + params);

            this.setState({
                opcionaisveiculos: response.data.data || [],
                totalItems: parseInt(response.data.info && response.data.info.totalrecords, 10) || 0
            });
        } catch (error) {
            console.error('Erro ao carregar opcionais de veículos:', error);

            this.setState({
                opcionaisveiculos: [],
                totalItems: 0
            });
        }
    };

    /* Muda a página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, this.loadOpcionaisVeiculo);
    };

    /* Muda a quantidade de retornos por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, this.loadOpcionaisVeiculo);
    };

    /* Deleta o opcional de veículo */
    handleDelete = async (id) => {
        try {
            const response = await api.delete(`/opcionalveiculo/${id}`);

            // verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleClose();
                this.loadOpcionaisVeiculo();
            }
        } catch (error) {
            this.handleClose();

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao excluir opcional de veículo!'
            );
        }
    };

    /* Confirma a exclusão */
    handleConfirmDelete = () => {
        const { selectedId } = this.state;

        this.handleDelete(selectedId);
    };

    /* Abre a janela de confirmação para a exclusão */
    handleOpen = (codopcionalveiculo, descopcionalveiculo) => {
        this.setState({
            open: true,
            selectedId: codopcionalveiculo,
            selectedDesc: descopcionalveiculo
        });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de confirmação da exclusão */
    handleClose = () => {
        this.setState({
            open: false,
            selectedId: null,
            selectedDesc: ''
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Pesquisa os filtros na tela */
    onChangeSearch = (event) => {
        const { name, value } = event.target;

        const searchFilter = {
            ...this.state.searchFilter,
            [name]: (typeof value === 'string') ? value.toUpperCase() : value
        };

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Limpa os filtros da tela */
    limpaFiltros = () => {
        const searchFilter = {
            descopcionalveiculo: '',
            situacaoInativoFilter: ANAO
        };

        this.setState({
            searchFilter,
            page: 0
        }, this.loadOpcionaisVeiculo);
    };

    render() {
        const {
            messageAlert,
            opcionaisveiculos,
            open,
            openAlert,
            page,
            rowsPerPage,
            searchFilter,
            selectedDesc,
            selectedId,
            totalItems
        } = this.state;

        const {
            actionIcon,
            addButton,
            iconGroup,
            redText
        } = this.estilo;

        return (
            <div style={this.estilo}>
                <Paper
                    hover
                    fullWidth
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        padding: '10px 20px',
                        gap: 15
                    }}
                >
                    <Input
                        autoFocus
                        id="descopcionalveiculo"
                        name="descopcionalveiculo"
                        onBlur={this.onInputBlur}
                        onChange={this.onChangeSearch}
                        placeholder="Opcional"
                        value={searchFilter.descopcionalveiculo}
                        style={{
                            flex: '0 1 200px',
                            minWidth: 200
                        }}
                    />

                    <Select
                        id="situacaoInativoFilter"
                        name="situacaoInativoFilter"
                        value={searchFilter.situacaoInativoFilter || ''}
                        onChange={this.onChangeSearch}
                        style={{
                            flex: '0 1 100px',
                            minWidth: 100,
                            textAlign: 'center'
                        }}
                    >
                        <MenuItem
                            value={ANAO}
                            style={{ justifyContent: 'center' }}
                        >
                            Ativos
                        </MenuItem>

                        <MenuItem
                            value={ASIM}
                            style={{ justifyContent: 'center' }}
                        >
                            Inativos
                        </MenuItem>

                        <MenuItem
                            value={'T'}
                            style={{ justifyContent: 'center' }}
                        >
                            Todos
                        </MenuItem>
                    </Select>

                    <span style={iconGroup}>
                        <Tooltip title="Procurar">
                            <SearchIcon
                                onClick={this.loadOpcionaisVeiculo}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>

                        <Tooltip title="Limpar">
                            <BackspaceOutlinedIcon
                                onClick={this.limpaFiltros}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>
                    </span>

                    <div style={{ flex: 1 }} />

                    <Button
                        component={Link}
                        to="/frotas/opcionalveiculo/novo"
                        variant="contained"
                        color="primary"
                        style={addButton}
                    >
                        Novo
                    </Button>
                </Paper>

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Código</TableCell>

                                            <TableCell align="center">Descrição</TableCell>

                                            <TableCell align="center">Ações</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {opcionaisveiculos.length === 0 && (
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    colSpan={3}
                                                >
                                                    Nenhum opcional de veículo encontrado
                                                </TableCell>
                                            </TableRow>
                                        )}

                                        {opcionaisveiculos.map(opcionalveiculo => (
                                            <TableRow
                                                hover
                                                key={opcionalveiculo.codopcionalveiculo}
                                            >
                                                <TableCell
                                                    align="center"
                                                    style={(opcionalveiculo.inativoopc === ASIM) ? redText : {}}
                                                >
                                                    {opcionalveiculo.codopcionalveiculo}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(opcionalveiculo.inativoopc === ASIM) ? redText : {}}
                                                >
                                                    {opcionalveiculo.descopcionalveiculo}
                                                </TableCell>

                                                <TableCell align="center">
                                                    <span style={iconGroup}>
                                                        <Tooltip title="Editar">
                                                            <Link to={`/frotas/opcionalveiculo/${opcionalveiculo.codopcionalveiculo}`}>
                                                                <EditTwoToneIcon
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>

                                                        <Tooltip title="Visualizar">
                                                            <Link to={`/frotas/opcionalveiculo/${opcionalveiculo.codopcionalveiculo}/view`}>
                                                                <VisibilityOutlinedIcon
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>

                                                        <Tooltip title="Excluir">
                                                            <DeleteForeverOutlinedIcon
                                                                onClick={() => this.handleOpen(
                                                                    opcionalveiculo.codopcionalveiculo,
                                                                    opcionalveiculo.descopcionalveiculo
                                                                )}
                                                                onMouseEnter={this.handleDeleteIconMouseEnter}
                                                                onMouseLeave={this.handleIconMouseLeave}
                                                                style={actionIcon}
                                                            />
                                                        </Tooltip>
                                                    </span>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>

                        <TablePagination
                            component="div"
                            count={totalItems}
                            onPageChange={this.handleChangePage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={[10, 50, 100, 200]}
                            labelRowsPerPage="Registros por página"
                        />
                    </CardContent>
                </Card>

                <DeleteConfirmationModal
                    open={open}
                    itemId={selectedId}
                    message={`Confirma exclusão do opcional de veículo ${selectedDesc || ''} [${selectedId}]?`}
                    handleClose={this.handleClose}
                    handleDelete={this.handleConfirmDelete}
                />

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default OpcionalVeiculoList;